import { FC, PropsWithChildren, useMemo, useState } from "react";

import { useForm } from "antd/es/form/Form";

import { StepFourFormContext } from "./StepFourFormContext";

// todo: ver que onda esta interfaz
export interface ActivitiesSectionForm {

}
export interface TableBeneficiaryItem {
    cuil:                             string;
    documentNumber:                   string;
    documentType:                     string;
    documentTypeDescription:          string;
    fullName:                         string;
    hasNoRepetitionClause:            boolean;
    hasNoRepetitionClauseDescription: string;
    key:                              string;
    personType?:                      string;
    holder:                          boolean;
    holderDescription:               string;
}

export const StepFourFormProvider: FC<PropsWithChildren> = ({ children }) => {
    const [ validitySectionForm ] = useForm<{ validityDate: any }>();

    const [ activitiesSectionForm ] = useForm<ActivitiesSectionForm>();

    const [ activitiesFormValues, setActivitiesFormValues ] = useState<ActivitiesSectionForm>();

    const [ methodSelectedFromStepThree, setMethodSelectedFromStepThree ] = useState<any>();

    const [ errorCreditCardMessage, setErrorCreditCardMessage ] = useState<string>('');

    const [ beneficiaries, setBeneficiaries ] = useState<Array<TableBeneficiaryItem>>([]);

    const values = useMemo(() => ({
        validitySectionForm,
        methodSelectedFromStepThree,
        setMethodSelectedFromStepThree,
        errorCreditCardMessage,
        setErrorCreditCardMessage,
        activitiesSectionForm,
        activitiesFormValues, 
        setActivitiesFormValues,
        beneficiaries, 
        setBeneficiaries,
    }), [
        validitySectionForm,
        methodSelectedFromStepThree,
        setMethodSelectedFromStepThree,
        errorCreditCardMessage,
        setErrorCreditCardMessage,
        activitiesSectionForm,
        activitiesFormValues, 
        setActivitiesFormValues,
        beneficiaries, 
        setBeneficiaries
    ]);

    return (
        <StepFourFormContext.Provider value={ values }>              
            { children }
        </StepFourFormContext.Provider>
    )
}